import React from 'react';
import * as PropTypes from 'prop-types';
import { Wrapper, OuterWrapper, Loader, Icon } from './elements';

function Load04(props) {
  return (
    <Wrapper className={props.className}>
      <OuterWrapper>
        <Loader />
        <Icon icon={props.icon} />
      </OuterWrapper>
    </Wrapper>
  );
}

Load04.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
};

export default Load04;
